import { Navigate } from "react-router";
import { useAuth } from "../context/AdminAuthContext";

export const StudentProtectedRoute = ({ children }) => {
  const { auth } = useAuth();

  // Check if user is authenticated and is a student
  if (!auth || auth.role !== "student") {
    return <Navigate to="/student-login" replace />;
  }

  return <>{children}</>;
};
